import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adminComponent from './admin.component';
import Entity from './entity/entity';
import List from './entity/list/list';
import EnquiryExtraManagement from './enquiryExtraManagement/enquiryExtraManagement'
import FinancialProductManagement from './financialProductManagement/financialProductManagement'
import EnquirySourceManagement from './enquirySourceManagement/enquirySourceManagement'
import RetailPriceList from './retailPriceList/retailPriceList'
import VehicleTradersManagement from './vehicleTradersManagement/vehicleTradersManagement'
import FinanceCompaniesManagement from './financeCompaniesManagement/financeCompaniesManagement'
import DeliveryPriceManagement from './deliveryPriceManagement/deliveryPriceManagement'
import DefaultTextManagement from './defaultTextManagement/defaultTextManagement'
import BrandModelManagement from './brandModelManagement/brandModelManagement'
import FailedWebEnquiries from './failedWebEnquiries/failedWebEnquiries'
import AutoPromiseManagement from './autoPromiseManagement/autoPromiseManagement'
import MonthlyDistributionManagement from './monthlyDistributionManagement/monthlyDistributionManagement'
import UserTargetsManagement from './userTargetsManagement/userTargetsManagement'
import EntityPreferences from './entityPreferences/entityPreferences'
import ReportsAccess from './reportsAccess/reportsAccess'
import DataUtility from './dataUtility/dataUtility'
import ScheduledReportsManagement from './scheduledReportsManagement/scheduledReportsManagement';

let adminModule = angular.module('admin', [
  uiRouter,
  Entity,
  EnquiryExtraManagement,
  FinancialProductManagement,
  EnquirySourceManagement,
  RetailPriceList,
  VehicleTradersManagement,
  FinanceCompaniesManagement,
  DeliveryPriceManagement,
  DefaultTextManagement,
  BrandModelManagement,
  FailedWebEnquiries,
  AutoPromiseManagement,
  MonthlyDistributionManagement,
  UserTargetsManagement,
  EntityPreferences,
  ReportsAccess,
  DataUtility,
  ScheduledReportsManagement,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('admin', {
      url: '/admin',
      component: 'admin'
    });

    $stateProvider
      .state('admin.listEntities', {
        url: '/listEntities',
        component: 'list'
      });
})

.component('admin', adminComponent)

.name;

export default adminModule;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin.js